import type { Product } from "@/mocks/products";

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <a
      href={product.link}
      target="_blank"
      rel="noopener nofollow"
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:border-primary-300"
    >
      <div className="aspect-square overflow-hidden bg-background-100">
        <img
          src={product.image}
          alt={product.name}
          title={product.name}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800">
          {product.name}
        </h3>
        <p className="mt-2 text-sm font-semibold text-accent-600">
          {product.price}
        </p>
        <span className="mt-2 inline-flex items-center text-xs font-medium text-primary-600">
          View Product
          <span className="ml-1 flex h-3 w-3 items-center justify-center">
            <i className="ri-external-link-line"></i>
          </span>
        </span>
      </div>
    </a>
  );
}